import axios from "axios";
import "mathquill/build/mathquill.css";
import { useEffect, useState } from "react";
import { addStyles, EditableMathField } from "react-mathquill";
import { useNavigate } from "react-router-dom";

addStyles();

const AddQuestionForm = () => {
  const [formData, setFormData] = useState({
    kelas: "",
    rombel: "",
    semester: "",
    mapel: "",
    jenis: "",
    TP: "",
    kode: 1,
    questions: [
      {
        text: "",
        gambar: "",
        type: "essay",
        keyJawabanBenar: 1,
        optionCorrectAnswer: [],
        bobot: 1,
        correctAnswer: "",
        options: [],
        mode: "text",
      },
    ],
    status: false,
  });

  const [questionPreviews, setQuestionPreviews] = useState({});
  const [optionPreviews, setOptionPreviews] = useState({});
  const handleMathChange = (value, index) => {
    const updated = [...formData.questions];
    updated[index].text = value; // latex disimpan sebagai string
    setFormData({ ...formData, questions: updated });
  };
  const navigate = useNavigate();
  const handleChange = (e, index, optionIndex) => {
    const { name, value } = e.target;

    // Update formData fields outside of questions
    if (
      ["kelas", "rombel", "mapel", "jenis", "TP", "semester"].includes(name)
    ) {
      setFormData({ ...formData, [name]: value });
      return;
    }

    // Clone questions array for safe updates
    const updatedQuestions = [...formData.questions];

    // Handle question-specific changes
    switch (name) {
      case "type":
        updatedQuestions[index].type = value;
        // Reset related fields based on question type
        if (value === "essay") {
          updatedQuestions[index].options = [];
          updatedQuestions[index].correctAnswer = "";
          updatedQuestions[index].optionCorrectAnswer = undefined;
        } else if (value === "isian") {
          updatedQuestions[index].optionCorrectAnswer = [];
          updatedQuestions[index].correctAnswer = undefined;
          updatedQuestions[index].options = undefined;
        } else if (value === "multipleChoice") {
          updatedQuestions[index].options = [
            { text: "", gambar: "", isCorrect: false, mode: "text" },
          ];
          updatedQuestions[index].correctAnswer = "";
          updatedQuestions[index].optionCorrectAnswer = undefined;
        }
        break;

      case "optionText":
        if (optionIndex !== undefined) {
          updatedQuestions[index].options[optionIndex].text = value;
        }
        break;

      case "correctAnswer":
        updatedQuestions[index].correctAnswer = value;
        break;

      case "bobot":
        updatedQuestions[index].bobot = Number(value);
        break;

      case "keyJawabanBenar":
        updatedQuestions[index].keyJawabanBenar = Number(value);
        break;

      default:
        if (name.startsWith("optionCorrectAnswer")) {
          const keyIndex = parseInt(
            name.replace("optionCorrectAnswer", ""),
            10,
          );
          if (keyIndex >= 0) {
            const updatedAnswers = [
              ...updatedQuestions[index].optionCorrectAnswer,
            ];
            updatedAnswers[keyIndex] = value;
            updatedQuestions[index].optionCorrectAnswer = updatedAnswers;
          }
        } else {
          updatedQuestions[index][name] = value;
        }
        break;
    }

    // Update the state with modified questions
    setFormData({ ...formData, questions: updatedQuestions });
  };

  const moveQuestion = (fromIndex, toIndex) => {
    setFormData((prevFormData) => {
      const updatedQuestions = [...prevFormData.questions];

      // Ambil elemen yang ingin dipindah
      const [movedQuestion] = updatedQuestions.splice(fromIndex, 1);

      // Sisipkan ke posisi baru
      updatedQuestions.splice(toIndex, 0, movedQuestion);

      return {
        ...prevFormData,
        questions: updatedQuestions,
      };
    });
  };

  const addQuestion = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      kode: prevFormData.kode + 1,
      questions: [
        ...prevFormData.questions,
        {
          text: "",
          type: "essay",
          bobot: 1,
          correctAnswer: "",
          options: [],
          mode: "text",
        },
      ],
    }));
  };

  const removeQuestion = (index) => {
    const updatedQuestions = [...formData.questions];
    updatedQuestions.splice(index, 1);
    setFormData((prevFormData) => ({
      ...prevFormData,
      kode: prevFormData.kode - 1,
      questions: updatedQuestions,
    }));
  };

  const addOption = (index) => {
    const updatedQuestions = [...formData.questions];
    updatedQuestions[index].options.push({
      text: "",
      gambar: "",
      isCorrect: false,
    });
    setFormData({ ...formData, questions: updatedQuestions });
  };

  const removeOption = (questionIndex, optionIndex) => {
    const updatedQuestions = [...formData.questions];
    updatedQuestions[questionIndex].options.splice(optionIndex, 1);
    setFormData({ ...formData, questions: updatedQuestions });
  };

  const handleImageUpload = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const preview = URL.createObjectURL(file);
    setQuestionPreviews((prev) => ({
      ...prev,
      [index]: preview,
    }));

    try {
      const formDataUpload = new FormData();
      formDataUpload.append("image", file);
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/questions/upload`,
        formDataUpload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ⬇ Pindahkan destructuring ke sini
      const { fileId, filename, mimetype } = response.data.image;

      setFormData((prev) => {
        const updatedQuestions = [...prev.questions];
        updatedQuestions[index].gambar = { fileId, filename, mimetype };
        return {
          ...prev,
          questions: updatedQuestions,
        };
      });
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleOptionImageUpload = async (e, questionIndex, optionIndex) => {
    const file = e.target.files[0];
    if (!file) return;

    const preview = URL.createObjectURL(file);
    setOptionPreviews((prev) => ({
      ...prev,
      [`${questionIndex}_${optionIndex}`]: preview,
    }));

    try {
      const formDataUpload = new FormData();
      formDataUpload.append("image", file);
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/questions/upload`,
        formDataUpload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ⬇ Pindahkan destructuring ke sini
      const { fileId, filename, mimetype } = response.data.image;

      setFormData((prev) => {
        const updated = [...prev.questions];
        updated[questionIndex].options[optionIndex].gambar = {
          fileId,
          filename,
          mimetype,
        };
        return { ...prev, questions: updated };
      });
    } catch (error) {
      console.error("Gagal upload gambar:", error);
    }
  };

  useEffect(() => {
    const data = localStorage.getItem("soalUpload");
    if (data) {
      try {
        const parsed = JSON.parse(data);
        console.log("Data dari localStorage:", parsed);

        // Periksa apakah semua properti penting ada dan valid
        const isValid =
          parsed &&
          typeof parsed === "object" &&
          Array.isArray(parsed.questions || parsed.question) &&
          parsed.kelas &&
          parsed.rombel &&
          parsed.semester &&
          parsed.mapel &&
          parsed.jenis &&
          parsed.TP;

        if (isValid) {
          // Ambil questions (antisipasi nama key berbeda)
          const rawQuestions = parsed.questions || parsed.question;

          // 🔥 Tambahkan default mode TEXT
          const fixedQuestions = rawQuestions.map((q) => ({
            ...q,
            mode: q.mode || "text", // default question mode
            options:
              q.options?.map((opt) => ({
                ...opt,
                mode: opt.mode || "text", // default option mode
              })) || [],
          }));

          // Gabungkan kembali
          const correctedData = {
            ...parsed,
            questions: fixedQuestions,
          };

          setFormData(correctedData);
          localStorage.removeItem("soalUpload");
        } else {
          console.warn("Struktur data tidak sesuai atau incomplete");
        }
      } catch (err) {
        console.error("Gagal parse JSON dari localStorage:", err);
      }
    }
  }, []);

  // Perbarui kode soal setiap kali jumlah pertanyaan berubah
  useEffect(() => {
    if (Array.isArray(formData.questions)) {
      setFormData((prev) => ({
        ...prev,
        kode: formData.questions.length,
      }));
    }
  }, [formData.questions]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }

      // Validasi formData
      if (
        !formData.kelas ||
        !formData.rombel ||
        !formData.semester ||
        !formData.mapel ||
        !formData.jenis
      ) {
        console.error("Please complete all required fields.");
        return;
      }

      // Hanya cek TP jika jenis bukan SAS/STS
      if (
        formData.jenis !== "SAS" &&
        formData.jenis !== "STS" &&
        !formData.TP
      ) {
        console.error("Please select TP.");
        return;
      }

      if (
        formData.questions.some(
          (q) =>
            !q.text ||
            q.bobot <= 0 ||
            (q.type === "multipleChoice" && q.options.length === 0),
        )
      ) {
        console.error("Some questions are incomplete or invalid.");
        return;
      }

      // Kirim request ke API
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/questions`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Reset form
      setFormData({
        kelas: "",
        rombel: "",
        semester: "",
        mapel: "",
        jenis: "",
        TP: "",
        kode: 1,
        questions: [
          {
            text: "",
            gambar: "",
            type: "essay",
            keyJawabanBenar: 0,
            bobot: 1,
            correctAnswer: "",
            options: [],
            optionCorrectAnswer: [],
            mode: "text",
          },
        ],
      });

      navigate("/guru");
    } catch (error) {
      if (error.response) {
        console.error("Error response from server:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error occurred:", error.message);
      }
    }
  };

  return (
    <div className="">
      <div className="flex justify-center items-center py-10 w-full">
        <h2 className="font-bold text-2xl">Add Questions</h2>
      </div>

      <form
        onSubmit={handleSubmit}
        className="grid  bg-blue-200/40  sm:mx-5 px-4 py-5 mb-10 rounded-lg "
      >
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-3 rounded-lg border border-slate-500/30 p-2 mb-5">
          <div className="flex items-center gap-1">
            <label className="font-bold">Kelas:</label>
            <select
              name="kelas"
              value={formData.kelas}
              onChange={handleChange}
              required
              className="rounded-lg py-2 px-3 w-full sm:w-auto min-w-[120px]"
            >
              <option value="">Kelas</option>
              {["1", "2", "3", "4", "5", "6"].map((kelas) => (
                <option key={kelas} value={kelas}>
                  {kelas}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <label className="font-bold">Rombel:</label>
            <select
              name="rombel"
              value={formData.rombel}
              onChange={handleChange}
              required
              className="rounded-lg py-2 px-3 w-full sm:w-auto min-w-[120px]"
            >
              <option value="">Rombel</option>
              {["A", "B", "C", "D"].map((rombel) => (
                <option key={rombel} value={rombel}>
                  {rombel}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <label className="font-bold">Semester:</label>
            <select
              name="semester"
              value={formData.semester}
              onChange={handleChange}
              required
              className="rounded-lg py-2 px-3 w-full sm:w-auto min-w-[120px]"
            >
              <option value="">Semester</option>
              {["1", "2"].map((semester) => (
                <option key={semester} value={semester}>
                  {semester}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <label className="font-bold">Mapel:</label>
            <select
              name="mapel"
              value={formData.mapel}
              onChange={handleChange}
              required
              className="rounded-lg py-2 px-3 w-full sm:w-auto min-w-[120px]"
            >
              <option value="">Mapel</option>
              {[
                // "IPA",
                // "IPS",
                "MTK",
                "BIndo",
                "BIng",
                "IPAS",
                "PAI",
                "PKN",
                "PJOK",
                "SENIBUDAYA",
                "MULOK",
                "Koding",
              ].map((mapel) => (
                <option key={mapel} value={mapel}>
                  {mapel}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <label className="font-bold">Jenis:</label>
            <select
              name="jenis"
              value={formData.jenis}
              onChange={handleChange}
              required
              className="rounded-lg py-2 px-3 w-full sm:w-auto min-w-[120px]"
            >
              <option value="">Jenis</option>
              {["Latihan", "Tugas", "PR", "UH", "STS", "SAS", "Praktikum"].map(
                (jenis) => (
                  <option key={jenis} value={jenis}>
                    {jenis}
                  </option>
                ),
              )}
            </select>
          </div>
          {formData.jenis !== "SAS" && formData.jenis !== "STS" && (
            <div className="flex items-center gap-1 mt-2">
              <label className="font-bold">TP:</label>
              <select
                name="TP"
                value={formData.TP || ""}
                onChange={handleChange}
                className="rounded-lg py-2 px-3 w-full sm:w-auto min-w-[200px]"
                required
              >
                <option value="">Pilih TP</option>
                {Array.from({ length: 20 }, (_, i) => (
                  <option key={i + 1} value={`TP${i + 1}`}>
                    TP {i + 1}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="flex items-center gap-1">
            <div>
              <h1 className="font-bold">Jumlah Soal:</h1>
            </div>
            <input
              className="bg-transparent w-full sm:w-auto"
              type="number"
              name="kode"
              value={formData.kode}
              readOnly
            />
          </div>
        </div>

        <h1 className="font-bold text-lg">Soal</h1>
        {formData.questions &&
          formData.questions.map((question, index) => (
            <div
              key={index}
              className="grid border border-slate-400/60 rounded-lg p-3 gap-y-3 mb-10 shadow-xl"
            >
              {/* <button
                onClick={() => moveQuestion(index, index - 1)}
                disabled={index === 0}
              >
                ⬆ Naik
              </button> */}
              <div className="flex gap-2">
                <button
                  onClick={(e) => {
                    e.preventDefault(); // cegah reload
                    moveQuestion(index, index - 1); // pindahkan soal
                  }}
                  className="bg-green-600 p-2 rounded-lg shadow-lg hover:bg-blue-400"
                >
                  ⬆ Naik kan No soal
                </button>

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    moveQuestion(index, index + 1);
                  }}
                  className="bg-green-600 p-2 rounded-lg shadow-lg hover:bg-blue-400"
                >
                  ⬇ Turun kan No soal
                </button>
              </div>

              <div className="grid">
                <label>Soal nomor {index + 1}:</label>
                <div className="flex gap-2 mb-2">
                  <button
                    type="button"
                    onClick={() => {
                      const updated = [...formData.questions];
                      updated[index].mode = "text";
                      setFormData({ ...formData, questions: updated });
                    }}
                    className={`px-3 py-1 rounded ${
                      question.mode === "text"
                        ? "bg-blue-500 text-white"
                        : "bg-gray-300"
                    }`}
                  >
                    Mode Text
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      const updated = [...formData.questions];
                      updated[index].mode = "math";
                      setFormData({ ...formData, questions: updated });
                    }}
                    className={`px-3 py-1 rounded ${
                      question.mode === "math"
                        ? "bg-blue-500 text-white"
                        : "bg-gray-300"
                    }`}
                  >
                    Mode Matematika
                  </button>
                </div>
                {question.mode === "text" ? (
                  <textarea
                    value={question.text}
                    onChange={(e) => {
                      const updated = [...formData.questions];
                      updated[index].text = e.target.value;
                      setFormData({ ...formData, questions: updated });
                    }}
                    className="w-full min-h-20 p-2 border rounded bg-white"
                    placeholder="Tulis soal "
                  />
                ) : (
                  <div className="w-full overflow-x-auto">
                    <div className="w-full">
                      <EditableMathField
                        latex={question.text}
                        onChange={(mathField) => {
                          const value = mathField.latex();
                          handleMathChange(value, index);
                        }}
                        className="
        w-full
        min-h-20 p-2 border rounded bg-white 
        text-base sm:text-lg md:text-xl
        whitespace-nowrap
      "
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2 sm:gap-3 flex-wrap ">
                <label
                  htmlFor={`image${index}`}
                  className="font-bold w-full sm:w-auto"
                >
                  Upload Image:
                </label>
                <input
                  type="file"
                  id={`image${index}`}
                  name="image"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, index)}
                  className="text-sm w-full sm:w-auto"
                />

                {questionPreviews[index] && (
                  <div className="mt-2">
                    <img
                      src={questionPreviews[index]}
                      alt={`Preview Soal ${index + 1}`}
                      className="w-32 h-32 object-cover rounded border"
                    />
                  </div>
                )}
              </div>

              <div>
                <label>Question Type:</label>
                <select
                  name="type"
                  value={question.type}
                  onChange={(e) => handleChange(e, index)}
                  className="rounded-lg px-4 py-2 w-full sm:w-auto"
                >
                  <option value="multipleChoice">Pilihan Ganda</option>
                  <option value="isian">Isian Singkat</option>
                  <option value="essay">Essay</option>
                </select>
              </div>

              <div>
                <label>Bobot:</label>
                <input
                  type="number"
                  name="bobot"
                  value={question.bobot}
                  onChange={(e) => handleChange(e, index)}
                  className="rounded-lg px-4 py-2 w-full sm:w-auto"
                  step="any"
                />
              </div>

              {question.type === "essay" && (
                <div className="grid">
                  <label>Correct Answer:</label>
                  <textarea
                    type="text"
                    name="correctAnswer"
                    value={question.correctAnswer}
                    onChange={(e) => handleChange(e, index)}
                    className="w-full h-20"
                  />
                </div>
              )}

              {question.type === "multipleChoice" && (
                <div>
                  <label>Options:</label>
                  {question.options.map((option, optionIndex) => (
                    <div
                      key={optionIndex}
                      className="flex gap-3 my-3 flex-wrap"
                    >
                      <div className="grid">
                        <div className="flex gap-2 mb-1">
                          <button
                            type="button"
                            onClick={() => {
                              const updated = [...formData.questions];
                              updated[index].options[optionIndex].mode = "text";
                              setFormData({ ...formData, questions: updated });
                            }}
                            className={`px-2 py-1 rounded ${
                              option.mode === "text"
                                ? "bg-blue-500 text-white"
                                : "bg-gray-300"
                            }`}
                          >
                            Mode Text
                          </button>

                          <button
                            type="button"
                            onClick={() => {
                              const updated = [...formData.questions];
                              updated[index].options[optionIndex].mode = "math";
                              setFormData({ ...formData, questions: updated });
                            }}
                            className={`px-2 py-1 rounded ${
                              option.mode === "math"
                                ? "bg-blue-500 text-white"
                                : "bg-gray-300"
                            }`}
                          >
                            Mode Matematika
                          </button>
                        </div>
                        {option.mode === "text" ? (
                          <textarea
                            name="optionText"
                            value={option.text}
                            onChange={(e) =>
                              handleChange(e, index, optionIndex)
                            }
                            className="
    w-full
    min-h-20
    p-2
    border
    rounded
    bg-white
    resize-y
    break-words
  "
                            placeholder="Tulis opsi"
                          ></textarea>
                        ) : (
                          <div className="w-full overflow-x-auto">
                            <EditableMathField
                              latex={option.text}
                              onChange={(mf) => {
                                const updated = [...formData.questions];
                                updated[index].options[optionIndex].text =
                                  mf.latex();
                                setFormData({
                                  ...formData,
                                  questions: updated,
                                });
                              }}
                              className="border rounded p-2 w-full bg-white min-h-10"
                            />
                          </div>
                        )}
                      </div>

                      <div className="flex items-center gap-1 flex-col sm:flex-row">
                        <label
                          htmlFor={`imageOption${index}_${optionIndex}`}
                          className="font-bold"
                        >
                          Upload Image:
                        </label>
                        <input
                          type="file"
                          id={`imageOption${index}_${optionIndex}`}
                          name="optionImage"
                          accept="image/*"
                          onChange={(e) =>
                            handleOptionImageUpload(e, index, optionIndex)
                          }
                          className="text-sm"
                        />

                        {optionPreviews[`${index}_${optionIndex}`] && (
                          <img
                            src={optionPreviews[`${index}_${optionIndex}`]}
                            alt={`Preview Option ${index + 1}`}
                            className="w-32 h-32 object-cover mt-2"
                          />
                        )}
                      </div>
                      <input
                        type="radio"
                        name={`correctAnswer${index}`}
                        value={optionIndex}
                        checked={option.isCorrect}
                        className="w-5 sm:w-4"
                        onChange={(e) => {
                          const updatedQuestions = [...formData.questions];
                          updatedQuestions[index].options = updatedQuestions[
                            index
                          ].options.map((opt, idx) => ({
                            ...opt,
                            isCorrect: idx === optionIndex,
                          }));
                          setFormData({
                            ...formData,
                            questions: updatedQuestions,
                          });
                          // eslint-disable-next-line no-lone-blocks
                          {
                            option.isCorrect && (
                              <span className="text-green-600 font-semibold">
                                Kunci
                              </span>
                            );
                          }
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => removeOption(index, optionIndex)}
                        className="px-3 rounded-lg bg-red-500/50 py-1 mt-2 sm:mt-0"
                      >
                        Hapus
                      </button>
                    </div>
                  ))}
                  <button
                    className="bg-blue-500/25 p-2 rounded-lg font-semibold w-full sm:w-auto"
                    type="button"
                    onClick={() => addOption(index)}
                  >
                    Tambah Pilihan
                  </button>
                </div>
              )}

              {question.type === "isian" && (
                <div>
                  <label>Jumlah jawaban benar:</label>
                  <input
                    type="number"
                    min="1"
                    value={question.keyJawabanBenar}
                    onChange={(e) => {
                      const keyJawabanBenar = parseInt(e.target.value, 10) || 0;
                      setFormData((prev) => {
                        const updatedQuestions = [...prev.questions];
                        updatedQuestions[index].keyJawabanBenar =
                          keyJawabanBenar;
                        return { ...prev, questions: updatedQuestions };
                      });
                    }}
                    className="rounded-lg px-4 py-2 w-full sm:w-auto"
                  />
                  <div className="mt-5">
                    <p>Kunci Jawaban</p>
                    {question.optionCorrectAnswer.map((answer, i) => (
                      <div key={i} className="flex items-center my-2">
                        <input
                          type="text"
                          value={answer}
                          onChange={(e) => {
                            const updatedAnswers = [
                              ...question.optionCorrectAnswer,
                            ]; // Copy answer array
                            updatedAnswers[i] = e.target.value; // Update specific answer

                            // Update state
                            setFormData((prev) => {
                              const updatedQuestions = [...prev.questions];
                              updatedQuestions[index].optionCorrectAnswer =
                                updatedAnswers;
                              return { ...prev, questions: updatedQuestions };
                            });
                          }}
                          className="rounded-lg px-4 py-2 border border-slate-300 flex-grow"
                          placeholder={`Jawaban ${i + 1}`}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setFormData((prev) => {
                              const updatedQuestions = [...prev.questions];
                              const updatedAnswers = [
                                ...updatedQuestions[index].optionCorrectAnswer,
                              ];
                              updatedAnswers.splice(i, 1); // Remove specific answer
                              updatedQuestions[index].optionCorrectAnswer =
                                updatedAnswers;
                              return { ...prev, questions: updatedQuestions };
                            });
                          }}
                          className="ml-2 text-red-500 hover:underline"
                        >
                          Hapus
                        </button>
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => {
                        setFormData((prev) => {
                          const updatedQuestions = JSON.parse(
                            JSON.stringify(prev.questions),
                          );
                          updatedQuestions[index].optionCorrectAnswer.push(""); // Add new answer
                          return { ...prev, questions: updatedQuestions };
                        });
                      }}
                      className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                    >
                      Tambah Jawaban
                    </button>
                  </div>
                </div>
              )}
              <div className="flex justify-end m-3">
                <button
                  className="bg-red-400 rounded-lg py-2 px-5 my-5 hover:bg-blue-400 hover:text-white "
                  type="button"
                  onClick={() => removeQuestion(index)}
                >
                  Hapus Soal
                </button>
              </div>
            </div>
          ))}

        <div className="mb-10 ">
          <button
            className="bg-blue-500  py-3 px-5 rounded-lg font-bold text-white hover:bg-blue-700"
            type="button"
            onClick={addQuestion}
          >
            Tambah Soal
          </button>
        </div>

        <button
          className="bg-blue-400 py-3 font-bold hover:bg-blue-800 hover:text-white  rounded-lg"
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddQuestionForm;
